import { get as getPlanMedia } from '@/api/planMedia';

// eslint-disable-next-line import/prefer-default-export
export async function gestionPlanMediaDcf(dcf, planMediaId) {
  const id = planMediaId || dcf?.planMediaId;
  if (!id) return null;
  const planMedia = (await getPlanMedia(id)).data.result;
  dcf.intervenants = planMedia.intervenants.map(i => {
    let newIntervenantContacts = [];
    if (i.contact) {
      newIntervenantContacts = [{
        contact: i.contact,
        contactId: i.contactId,
        contactTypes: [],
      }];
    }
    return {
      ...i,
      intervenantContacts: newIntervenantContacts,
    };
  });
  dcf.planMediaId = planMedia.id;
  dcf.commercialId = planMedia.commercialId;
  dcf.commissions = planMedia.commissions;
  if (Array.isArray(dcf.commissions)
    && dcf.commissions.length > 0) {
    const maxCommission = dcf.commissions
      .sort((a, b) => b.pourcentageRepartition - a.pourcentageRepartition)[0];
    dcf.commercialId = maxCommission.commercialId;
  }
  return planMedia;
}
